import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
// import CCustoBadge from '../ccustos/CCustoBadge';

const MovimentacaoRow = (props) => {
    let colorCode;
    if (props.tipo === 'REC')
        colorCode = props.status ? 'receitaPaga' : 'receitaPendente';
    else
        colorCode = props.status ? 'despesaPaga' : 'despesaPendente';

    // let removeAll = null;
    // if (props.parcelamento_id) {
    //     removeAll = (
    //         < i className="fas fa-eraser" style={{ cursor: "pointer" }} onClick={() => props.handleDeletePendings(props.parcelamento_id)} />
    //     );
    // }

    return (
        <li className={`list-group-item list-group-item-action flex-column align-items-start ${colorCode}`} data-test="mov-row">
            <div className="row">
                <div className="col-12 col-md-9">
                    <div className="d-flex w-100 justify-content-between">
                        <span>
                            {props.descricao}
                        </span>
                        <small>{parseFloat(props.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</small>
                    </div>
                    <div className="d-flex w-100 justify-content-between">
                        <small className="d-none d-md-block">{props.envolvido}</small>
                        <small>{props.conta}</small>
                    </div>
                    <div className="d-flex w-100 justify-content-between">
                        <small>{moment(props.data_transacao).format('DD/MM/YYYY')} - {moment(props.data_pagamento).format('DD/MM/YYYY')}</small>
                        <small className="d-none d-md-block">{props.observacao}</small>
                    </div>
                </div>

                <div className="col col-md-1">
                    <Link to={`/movimentacao/${props.id}`}>
                        <i className="fas fa-edit" style={{ cursor: "pointer" }} title={"Alterar id: " + props.id} />
                    </Link>
                    {" | "}
                    <a href="#" onClick={() => props.handleDelete(props.id)} >
                        <i className="far fa-trash-alt" style={{ cursor: "pointer" }}  title={"Deletar id: " + props.id} />
                    </a>

                </div>
            </div>
        </li>
    );
};

MovimentacaoRow.propTypes = {
    tipo: PropTypes.string.isRequired,
    status: PropTypes.bool.isRequired,
    descricao: PropTypes.string.isRequired,
    envolvido: PropTypes.string.isRequired,
    observacao: PropTypes.string,
    conta: PropTypes.string.isRequired,
    valor: PropTypes.string.isRequired,
    // acumulado: PropTypes.number.isRequired,
    data_pagamento: PropTypes.string.isRequired,
    data_transacao: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    parcelamento_id: PropTypes.number,
    handleDelete: PropTypes.func.isRequired,
    // handleDeletePendings: PropTypes.func.isRequired,
    // handlePay: PropTypes.func.isRequired,
    // ccustos: PropTypes.array.isRequired,
};

export default MovimentacaoRow;


// WEBPACK FOOTER //
// ./src/components/relatorios/MovimentacaoRow.js